import * as THREE from 'three';
import { G, M, TINT, HP, glowMat, mesh, mergeBones, stages, boneG } from './kit';
/* ============================================================
   SPALTER 裂解者 —— BOSS・分裂
   ============================================================

   剪影：1→4→12 顆八面體
   階段：'P1 單體・硬','P2 裂成四顆・包夾','P3 裂成十二顆・兩層公轉'

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-09 SPALTER 裂解者 ── 分裂：1 → 4 → 12。
   同一份幾何，只是數量與大小在變 —— 這是「幾何是限制」最直接的一個示範。
   P1 一顆大的，好打但硬。P2 四顆中的，開始包夾。P3 十二顆小的，兩層公轉。
   血量條的意義從「打穿」變成「清場」。 */
var SPN = 12;
export function buildSpalter(){
  var GLV = glowMat(TINT.vio.hex, 2.3);
  var root = new THREE.Group(), shards = [], i;
  for (i = 0; i < SPN; i++){
    var sd = boneG(root, 0, 3.00, 0);
    sd.add(mesh(G.oct, M.dark,  [1.60,1.60,1.60], [0,0,0]));
    sd.add(mesh(G.tor, M.armor, [2.10,2.10,0.46], [0,0,0], [HP,0,0]));
    sd.add(mesh(G.tor, M.armor, [1.98,1.98,0.46], [0,0,0], [0,HP,0]));
    sd.add(mesh(G.cone, M.trim, [0.44,0.90,0.44], [0, 1.00,0]));
    sd.add(mesh(G.cone, M.trim, [0.44,0.90,0.44], [0,-1.00,0], [Math.PI,0,0]));
    var gm = mesh(G.oct, GLV, [0.80,0.80,0.80], [0,0,0]);
    gm.userData.noMerge = 1; sd.add(gm); sd.userData.gm = gm;
    shards.push(sd);
  }
  root.userData.rig = {shards:shards, GLV:GLV};
  return mergeBones(root);
}
export function updSpalter(rig, o, dt){
  stages(rig, o, dt, 1.8);
  var s1 = rig.s1, s2 = rig.s2, i, sd;
  var n = (s2 > 0.5) ? 12 : (s1 > 0.5 ? 4 : 1);
  var sc = 1 - 0.46*s1 - 0.28*s2;                  // 1.00 → 0.54 → 0.26
  for (i = 0; i < SPN; i++){
    sd = rig.shards[i];
    sd.visible = i < n;
    if (!sd.visible) continue;
    var ring = i < 4 ? 0 : 1;
    var cnt  = n === 12 ? (ring ? 8 : 4) : n;
    var idx  = n === 12 ? (ring ? i - 4 : i) : i;
    var rad  = (n === 1) ? 0 : (ring ? 4.30 : 2.40) * (n === 4 ? 0.92 : 1);
    var a    = idx*Math.PI * 2/cnt + o.t*(ring ? -0.55 : 0.75)*(n > 1 ? 1 : 0);
    sd.position.set(Math.sin(a)*rad, 3.00 + (ring ? 1.10 : 0) + 0.22*Math.sin(o.t*1.4 + i),
                    Math.cos(a)*rad);
    sd.rotation.y = a; sd.rotation.x = o.t*0.6 + i;
    sd.scale.setScalar(sc*(1 + 0.35*o.tel));
    sd.userData.gm.scale.setScalar(1 + 0.20*Math.sin(o.t*4 + i) + 1.3*o.tel);
  }
  rig.GLV.emissiveIntensity = 2.3 + 2.4*o.tel + 6*o.atk*(1-o.atk) + 1.2*s2;
}